var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "boss-main-container" }, [
    _c(
      "div",
      { staticClass: "boss-main-wrap boss-main-content-wrap display-inherit" },
      [
        _c("setting-header", {
          attrs: {
            breadcrumbs: [{ name: "各種設定" }],
            title: "応募者管理＿一覧画面の表示情報の設定",
          },
        }),
        _vm._v(" "),
        _c("table", { staticClass: "boss-table-4" }, [
          _c(
            "tr",
            { attrs: { "data-test": "tr-preview" } },
            [
              _vm._l(_vm.defaultEntryDisplayItems, function (item, i) {
                return _c("th", { key: i }, [
                  _vm._v("\n          " + _vm._s(item.name) + "\n        "),
                ])
              }),
              _vm._v(" "),
              _vm._l(_vm.selectedItems, function (item, i) {
                return _c("th", { key: i + "-" + item.id }, [
                  _vm._v("\n          " + _vm._s(item.name) + "\n        "),
                ])
              }),
            ],
            2
          ),
        ]),
        _vm._v(" "),
        _c(
          "div",
          {
            staticClass:
              "boss-selection-container pega-select-container clearfix",
          },
          [
            _c(
              "div",
              {
                staticClass: "boss-select-container pega-select-container-left",
              },
              [
                _vm._m(0),
                _vm._v(" "),
                _c("div", { staticClass: "boss-select-wrap" }, [
                  _c(
                    "ul",
                    {
                      staticClass:
                        "boss-select-lis pega-clear-padding display-entry-setting-left-height",
                      attrs: { "data-test": "selected-item" },
                    },
                    [
                      _c(
                        "div",
                        {
                          staticClass:
                            "pega-drag-area padding-bottom-0 min-height-0",
                        },
                        _vm._l(
                          _vm.defaultEntryDisplayItems,
                          function (item, i) {
                            return _c(
                              "li",
                              {
                                key: i,
                                staticClass:
                                  "boss-select-item boss-no-move pega-no-move",
                              },
                              [
                                _c("span", {
                                  staticClass: "boss-select-item-text",
                                  domProps: { innerHTML: _vm._s(item.name) },
                                }),
                              ]
                            )
                          }
                        ),
                        0
                      ),
                      _vm._v(" "),
                      _vm.isDragging
                        ? _c(
                            "div",
                            {
                              staticClass:
                                "pega-drop-area border-dashed margin-bottom-1",
                              attrs: { "data-test": "drop-area" },
                            },
                            [
                              _c("p", [
                                _vm._v(
                                  "↓ この範囲に要素をドラッグしてください"
                                ),
                              ]),
                            ]
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _c(
                        "draggable",
                        {
                          staticClass:
                            "pega-drag-area padding-top-0 min-height-entry-columns",
                          attrs: {
                            group: "items",
                            "data-test": "draggable-selected",
                          },
                          on: {
                            start: _vm.changeDragging,
                            end: _vm.changeDragging,
                          },
                          model: {
                            value: _vm.selectedItems,
                            callback: function ($$v) {
                              _vm.selectedItems = $$v
                            },
                            expression: "selectedItems",
                          },
                        },
                        _vm._l(_vm.selectedItems, function (item, i) {
                          return _c(
                            "li",
                            {
                              key: i + "-" + item.id,
                              staticClass: "boss-select-item boss-any",
                            },
                            [
                              _c("span", {
                                staticClass: "boss-select-item-text",
                                domProps: { innerHTML: _vm._s(item.name) },
                              }),
                              _vm._v(" "),
                              _c("span", { staticClass: "boss-any-text" }, [
                                _vm._v("任意"),
                              ]),
                            ]
                          )
                        }),
                        0
                      ),
                      _vm._v(" "),
                      _vm.isDragging
                        ? _c(
                            "div",
                            {
                              staticClass: "pega-drop-area bottom",
                              attrs: { "data-test": "drop-area" },
                            },
                            [
                              _c("p", [
                                _vm._v(
                                  "↑ この範囲に要素をドラッグしてください"
                                ),
                              ]),
                            ]
                          )
                        : _vm._e(),
                    ],
                    1
                  ),
                ]),
              ]
            ),
            _vm._v(" "),
            _vm._m(1),
            _vm._v(" "),
            _c("div", { staticClass: "boss-select-container" }, [
              _vm._m(2),
              _vm._v(" "),
              _c("div", { staticClass: "boss-select-wrap" }, [
                _c(
                  "ul",
                  {
                    staticClass: "boss-select-list pega-clear-padding",
                    attrs: { "data-test": "unselected-item" },
                  },
                  [
                    _vm.isDragging
                      ? _c(
                          "div",
                          {
                            staticClass: "pega-drop-area top",
                            attrs: { "data-test": "drop-area" },
                          },
                          [
                            _c("p", [
                              _vm._v("↓ この範囲に要素をドラッグしてください"),
                            ]),
                          ]
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _c(
                      "draggable",
                      {
                        staticClass: "pega-drag-area",
                        attrs: {
                          group: "items",
                          "data-test": "draggable-unselected",
                        },
                        on: {
                          start: _vm.changeDragging,
                          end: _vm.changeDragging,
                        },
                        model: {
                          value: _vm.unselectedItems,
                          callback: function ($$v) {
                            _vm.unselectedItems = $$v
                          },
                          expression: "unselectedItems",
                        },
                      },
                      _vm._l(_vm.unselectedItems, function (item) {
                        return _c(
                          "li",
                          {
                            key: item.id,
                            staticClass:
                              "boss-select-item boss-no-move boss-any",
                          },
                          [
                            _c("span", {
                              staticClass: "boss-select-item-text",
                              domProps: { innerHTML: _vm._s(item.name) },
                            }),
                            _vm._v(" "),
                            _c("span", { staticClass: "boss-any-text" }, [
                              _vm._v(
                                "\n                  任意\n                "
                              ),
                            ]),
                          ]
                        )
                      }),
                      0
                    ),
                    _vm._v(" "),
                    _vm.isDragging
                      ? _c(
                          "div",
                          {
                            staticClass: "pega-drop-area bottom",
                            attrs: { "data-test": "drop-area" },
                          },
                          [
                            _c("p", [
                              _vm._v("↑ この範囲に要素をドラッグしてください"),
                            ]),
                          ]
                        )
                      : _vm._e(),
                  ],
                  1
                ),
              ]),
            ]),
          ]
        ),
        _vm._v(" "),
        _c("div", { staticClass: "boss-button-container" }, [
          _c(
            "button",
            {
              staticClass: "boss-button boss-button-return",
              attrs: { "data-test": "back" },
              on: {
                click: function ($event) {
                  return _vm.$router.back()
                },
              },
            },
            [
              _c("span", { staticClass: "boss-button-return-text" }, [
                _vm._v("戻る"),
              ]),
            ]
          ),
          _vm._v(" "),
          _c(
            "button",
            {
              staticClass: "boss-button boss-button-confirm",
              attrs: { "data-test": "update-button" },
              on: { click: _vm.updateDisplayItems },
            },
            [
              _c("span", { staticClass: "boss-button-confirm-text" }, [
                _vm._v("登録する"),
              ]),
            ]
          ),
        ]),
      ],
      1
    ),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "boss-select-title" }, [
      _c("span", { staticClass: "boss-select-text" }, [
        _vm._v("設定されている表示項目"),
      ]),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "boss-center-container" }, [
      _c("div", { staticClass: "boss-arrow" }),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "boss-select-title" }, [
      _c("span", { staticClass: "boss-select-text" }, [
        _vm._v("表示したい項目を右枠から左枠にドラッグしてください。"),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }